import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import './Company.css';

export default class Company extends React.Component {

  static contextTypes = {
    intl: PropTypes.object.isRequired
  };

  static propTypes = {
    className: PropTypes.string,
    onClickViewBusinessButton: PropTypes.func
  };

  state = {
    isLoaded: false
  };

  render() {
    return (
      <div className={classnames('Company', this.props.className)}>
      {
        /*
        <div
          id="Company__particleJS"
          className="Company__particleJS"
        />
        */
      }
        <div
          className="Company__bgWrapper">
          <img
            className={classnames('Company__bg', {
              'Company__bg--loaded': this.state.isLoaded
            })}
            src={require('../images/Company-bg.jpg')}
            alt="Hansuk International LTD."
            onLoad={this._onLoad}
          />
        </div>
        <div className="Company__content">
          <h2 className="Company__title">
            <FormattedMessage id="Company.title"/>
          </h2>
          <div
            className="Company__description"
            dangerouslySetInnerHTML={{
              __html: this.context.intl.formatMessage({ id: 'Company.description' })
            }}
          />
          <h3 className="Company__profileTitle">  
            <FormattedMessage id="Company.profileTitle"/>
          </h3>
          <div className="Company__profileDescriptions">
            <div className="Company__profileDescription">  
              <FormattedMessage id="Company.profileDescription"/>
            </div>
            <div
              className="Company__profileDescriptionEnglish"
              dangerouslySetInnerHTML={{
                __html: this.context.intl.formatMessage({ id: 'Company.profileDescriptionEnglish' })
              }}
            />
          </div>
          <h3 className="Company__businessTitle">  
            <FormattedMessage id="Company.businessTitle"/>
          </h3>
          <button
            className="Company__viewBusinessButton"
            onClick={this._onClickViewBusinessButton}>
            <span className="Company__viewBusinessButtonLabel">
              <FormattedMessage id="Company.viewBusiness"/>
            </span>
            <span className="Company__viewBusinessButtonIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#FFF" d="M8.46966991,17.4696699 C8.1767767,17.7625631 8.1767767,18.2374369 8.46966991,18.5303301 C8.76256313,18.8232233 9.23743687,18.8232233 9.53033009,18.5303301 L16.0606602,12 L9.53033009,5.46966991 C9.23743687,5.1767767 8.76256313,5.1767767 8.46966991,5.46966991 C8.1767767,5.76256313 8.1767767,6.23743687 8.46966991,6.53033009 L13.9393398,12 L8.46966991,17.4696699 Z"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
    );
  }

  _onLoad = () => {
    this.setState({
      isLoaded: true
    });
  };

  _onClickViewBusinessButton = () => {
    this.props.onClickViewBusinessButton();
  };

  // componentDidMount() {
  //   window.particlesJS.load('Company__particleJS', {
  //     "particles": {
  //       "number": {
  //         "value": 200,
  //         "density": {
  //           "enable": false,
  //           "value_area": 1183.721462448409
  //         }
  //       },
  //       "color": {
  //         "value": "#ba8b4d"
  //       },
  //       "shape": {
  //         "type": "circle",
  //         "stroke": {
  //           "width": 0,
  //           "color": "#000000"
  //         },
  //         "polygon": {
  //           "nb_sides": 6
  //         },
  //         "image": {
  //           "src": "img/github.svg",
  //           "width": 100,
  //           "height": 100
  //         }
  //       },
  //       "opacity": {
  //         "value": 0.5129459670609773,
  //         "random": true,
  //         "anim": {
  //           "enable": false,
  //           "speed": 6.553446553446554,
  //           "opacity_min": 0.23176823176823177,
  //           "sync": false
  //         }
  //       },
  //       "size": {
  //         "value": 2.5,
  //         "random": false,
  //         "anim": {
  //           "enable": false,
  //           "speed": 4,
  //           "size_min": 0.3,
  //           "sync": false
  //         }
  //       },
  //       "line_linked": {
  //         "enable": true,
  //         "distance": 160,
  //         "color": "#ba8b4d",
  //         "opacity": 0.28409315098761817,
  //         "width": 1.5
  //       },
  //       "move": {
  //         "enable": true,
  //         "speed": 0.4,
  //         "direction": "none",
  //         "random": true,
  //         "straight": false,
  //         "out_mode": "out",
  //         "bounce": false,
  //         "attract": {
  //           "enable": false,
  //           "rotateX": 600,
  //           "rotateY": 600
  //         }
  //       }
  //     },
  //     "interactivity": {
  //       "detect_on": "canvas",
  //       "events": {
  //         "onhover": {
  //           "enable": false,
  //           "mode": "bubble"
  //         },
  //         "onclick": {
  //           "enable": false,
  //           "mode": "repulse"
  //         },
  //         "resize": true
  //       },
  //       "modes": {
  //         "grab": {
  //           "distance": 400,
  //           "line_linked": {
  //             "opacity": 1
  //           }
  //         },
  //         "bubble": {
  //           "distance": 250,
  //           "size": 0,
  //           "duration": 2,
  //           "opacity": 0,
  //           "speed": 3
  //         },
  //         "repulse": {
  //           "distance": 400,
  //           "duration": 0.4
  //         },
  //         "push": {
  //           "particles_nb": 4
  //         },
  //         "remove": {
  //           "particles_nb": 2
  //         }
  //       }
  //     },
  //     "retina_detect": true
  //   });
  // }

  // componentWillUnmount() {
  //   try {
  //     if (window.pJSDom instanceof Array && window.pJSDom.length > 0) {
  //       window.pJSDom
  //         .map(element => element.pJS.fn.vendors)
  //         .forEach(vendors => {
  //           vendors.destroypJS();
  //         });
  //       window.pJSDom = [];
  //     }      
  //   } catch (err) {}
  // }

}



// WEBPACK FOOTER //
// ./src/components/Company.js